import { useEffect, useState } from 'react'
import { ShipmentBoxesList } from 'src/_modules/MapitShip/components'
import { useTranslation } from 'react-i18next'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography, useMediaQuery } from '@mui/material'
import { Clear } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { useUpdateMapitShipOrderMutation } from 'src/_api/mapitShipApi'
import { cloneDeep, map, mapValues, omit, set } from 'lodash'
import { runJoiValidate } from 'src/_utils'
import { SHIPMENT_BOXS_LIST_SCHEMA } from '../../../validationSchemas'

export default function ShipmentBoxesListDialog({ boxesData, orderId, open, onClose }) {
    const { t } = useTranslation()
    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    const [boxes, setBoxes] = useState([])

    useEffect(() => {
        if (!!boxesData?.length) {
            setBoxes(boxesData)
        }
    }, [boxesData])

    const handleChange = ({ target: { value } }) => {
        setBoxes(value)
    }

    const addNewBox = () => {
        setBoxes((prev) => [...prev, { dimensions: { length: '', width: '', height: '' }, weight: 1 }])
    }

    const [updateOrder, { isLoading, isSuccess, error }] = useUpdateMapitShipOrderMutation()
    const [validationErrors, setValidationErrors] = useState({})

    const onSubmit = async () => {
        try {
            setValidationErrors(null)


            let payload = map(cloneDeep(boxes), box => {
                box = omit(box, ['_id'])
                box.dimensions = mapValues(box.dimensions, Number);
                box.weight = Number(box.weight);
                return box
            })

            const errors = runJoiValidate(SHIPMENT_BOXS_LIST_SCHEMA, payload)

            console.log("onSubmit", boxes)
            console.log("errors", errors)

            if (!!errors) {
                setValidationErrors(errors)
                return
            }
            await updateOrder({
                id: orderId,
                payload: {
                    boxes: payload,
                    weight: payload.reduce((acc, box) => acc + box.weight, 0),
                    packagesCount: payload.length
                }
            }).unwrap()

            setTimeout(() => {
                onClose()
            }, 2000)

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!open) {
            setBoxes([])
            setValidationErrors(null)
        }
    }, [open])

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            fullScreen={fullScreen}
            onClose={(e) => e.preventDefault()}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                {t("Create Shipment")}
                <IconButton sx={{ ml: "auto" }} onClick={onClose} color="primary">
                    <Clear />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <ShipmentBoxesList boxes={boxes ?? []} onChange={handleChange} errors={validationErrors} />
            </DialogContent>
            <Divider />
            <DialogActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <Button
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    onClick={addNewBox}
                >{t("Add Box")}
                </Button>
                <LoadingButton
                    type="button"
                    loading={isLoading}
                    onClick={onSubmit}
                    color="primary"
                    variant="contained"
                    sx={{ textTransform: "none" }}
                >
                    {t("Confirm")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
